import * as permissao from '@/api/permissao'

const state = {
  lista: [],
  listaSelect: []
}

const mutations = {
  SETPERMISSOES (state, payload) {
    state.lista = payload
  }
}

const actions = {
  async getPermissoes ({ commit }, payload) {
    let data = await permissao.list(payload)
    commit('SETPERMISSOES', data)
  }
}

export default { namespaced: true, state, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/gerenciador/permissoes.js